import { Box } from '@packages/shared';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'urql';
import { graphql } from '@packages/gql/generated/shopping';
import { useConfig } from '@packages/utilities';
import { useIntl } from 'react-intl';
import { useRatingFilterTag } from '../useRatingFilterTag';
import { LoadMore } from '../LoadMore';
import { Review } from '../Review';

export const RatingDataDocument = graphql(/* GraphQL */ `
  query ReviewsData(
    $productId: String!
    $locale: String!
    $start: Int!
    $count: Int!
    $filter: String
  ) {
    rating(id: $productId, locale: $locale, start: $start, count: $count, filter: $filter) {
      product {
        reviewCount
        reviews {
          id
          ...ReviewFragment
        }
      }
    }
  }
`);

/**
 * Paginated list of ratings with load more button
 */
export const RatingList = () => {
  const [cursor, setCursor] = useState(0);
  const {
    customerRatings: { pagingCount },
  } = useConfig();
  const {
    query: { akl, slug },
    asPath,
  } = useRouter();
  const { locale } = useIntl();

  const { filterTagFromUrl: filter } = useRatingFilterTag();

  // reset cursor after applying, changing or removing filter
  useEffect(() => {
    setCursor(0);
  }, [asPath]);

  const [{ data }] = useQuery({
    query: RatingDataDocument,
    variables: {
      // productId: ((sku || (akl ?? slug)) as string)!,
      productId: ((akl ?? slug) as string)!,
      locale: locale!,
      start: cursor,
      count: pagingCount,
      filter,
    },
    context: useMemo(() => ({ suspense: false }), []),
  });

  const product = data?.rating?.product;
  if (!product) {
    return null;
  }

  const { reviews, reviewCount } = product;

  return (
    <>
      <Box
        sx={{
          width: '100%',
          m: 0,
          p: 0,
          mb: 3,
          li: { listStyleType: 'none', '& + li': { mt: [1.5, 2] } },
        }}
        component="ul"
      >
        {reviews.map(({ id, ...review }) => (
          <Box component="li" key={id}>
            <Review reviewData={review} />
          </Box>
        ))}
      </Box>
      <LoadMore
        shown={reviews.length}
        reviewCount={reviewCount}
        onLoadMore={() => setCursor(reviews.length)}
      />
    </>
  );
};
